var map = {
	"./de": 4969,
	"./de.json": 4969,
	"./en": 4970,
	"./en-GB": 4971,
	"./en-GB.json": 4971,
	"./en.json": 4970,
	"./es": 4972,
	"./es.json": 4972,
	"./fr": 4973,
	"./fr.json": 4973,
	"./he": 4974,
	"./he.json": 4974,
	"./it": 4975,
	"./it.json": 4975,
	"./ja": 4976,
	"./ja.json": 4976,
	"./ko": 4977,
	"./ko.json": 4977,
	"./nl": 4978,
	"./nl.json": 4978,
	"./pt": 4979,
	"./pt.json": 4979,
	"./ru": 4980,
	"./ru.json": 4980,
	"./vi": 4981,
	"./vi.json": 4981,
	"./zh-Hans": 4982,
	"./zh-Hans.json": 4982,
	"./zh-Hant": 4983,
	"./zh-Hant-TW": 4984,
	"./zh-Hant-TW.json": 4984,
	"./zh-Hant.json": 4983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5164;